import React from "react";
import {Chip} from "@mui/material";

const EffectChip = ({effect}) => {
    if (!effect) {
        return null;
    }

    return (
        <Chip
            label={effect}
            size="small"
            variant="outlined"
            sx={{
                height: 'auto',
                alignSelf: 'flex-start',
                borderColor: 'divider',
                color: 'text.secondary',
                fontWeight: 600,
                fontSize: '0.75rem',
                '& .MuiChip-label': {
                    py: 0.5,
                    px: 1,
                    whiteSpace: 'normal',
                    lineHeight: 1.4,
                },
            }}
        />
    );
};

export default EffectChip;
